export default __webpack_public_path__ + "static/media/turn-left.eed69699.svg";